import * as React from 'react';
import tip from './tip.svg';
import styles from './tooltip.module.css';

export type TTooltipProps = {
	text: string;
	heading: string;
};

const Tooltip: React.StatelessComponent<TTooltipProps> = ({ text, heading }) => {
	return (
		<div className={`${styles.tooltipBox}`}>
			<div className={`${styles.tooltipHeading}`}>
				<img src={tip} className={`${styles.tipImg}`} />
				<span className={`${styles.text} ${styles.textWrap}`}>{heading}</span>
			</div>
			<div className={`${styles.tooltipText}`} dangerouslySetInnerHTML={{ __html: text }}></div>
		</div>
	);
};

export default Tooltip;
